import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { Product } from '@df/catalog/product/product';
import { IStoreDataV3 } from '@df/catalog/store/store';
import { Status } from '@df/core/status';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentComponent } from '@icms/core/content';
import { LocalStore } from '../../catalog/store/store.decorator';
import { NModalLayout } from '../../common/modal/layout/modal-layout.component';
import { BranchService } from '../branch.service';

export namespace NCmsBranchCollection {
    export const MODAL_ID = 'branch-collection';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        title: string;
    }

    export interface IModalData {
        product: Product;
    }
}

@DfModal({
    id: NCmsBranchCollection.MODAL_ID,
    name: 'Branch Collection',
    position: sizeName => (sizeName === 'X' || sizeName === 'L' ? 'right' : 'bottom'),
    config: size => ({
        ...(['S', 'M'].includes(size) ? NModalLayout.Bottom.modalConfig()(size) : NModalLayout.Right.modalConfig()(size)),
        modalClass: 'b-radius-4-top p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['X', 'L', 'M', 'S'],

    prerenderAllowed: false
})
@Component({
    selector: 'branch-collection',
    templateUrl: './branch-collection.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchCollectionComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    private branchService = inject(BranchService);
    private modalRef = inject(ModalRef<BranchCollectionComponent>);
    protected modalData = inject(MODAL_DATA) as NCmsBranchCollection.IModalData;

    protected selectedBranchNumber: number | undefined;
    protected status = new Status();

    protected handleBranchChange(store: LocalStore<IStoreDataV3>) {
        if (store?.data?.branch_number) {
            this.selectedBranchNumber = store.data.branch_number;
            this.detectChanges();
        }
    }

    protected confirm(): void {
        if (this.selectedBranchNumber) {
            this.branchService.updateBranch(
                this.selectedBranchNumber,
                () => {
                    this.modalRef.close();
                },
                undefined,
                this.status
            );
        }
    }
}
